"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardColor = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _heading = _interopRequireWildcard(require("../heading"));
var _paragraph = _interopRequireDefault(require("../paragraph"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Card
// ====
let CardColor = exports.CardColor = /*#__PURE__*/function (CardColor) {
  CardColor["white"] = "white";
  CardColor["none"] = "none";
  return CardColor;
}({});
const CardHeader = _ref => {
  let {
    title,
    heading,
    subHeading,
    headingProps,
    headerElement,
    headerUnderline
  } = _ref;
  const headerElements = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.title
  }, title), heading && /*#__PURE__*/_react.default.createElement(_heading.default, (0, _extends2.default)({
    type: _heading.HeadingSize.large
  }, headingProps), heading), subHeading && /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.subHeading
  }, /*#__PURE__*/_react.default.createElement(_paragraph.default, null, subHeading)), headerElement && /*#__PURE__*/_react.default.createElement("div", null, headerElement));
  return headerUnderline ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      [_indexModule.default.headerUnderlined]: headerUnderline
    })
  }, headerElements) : headerElements;
};
const Card = _ref2 => {
  let {
    title,
    heading,
    subHeading,
    headingProps,
    className,
    children,
    headerElement,
    cardColor = CardColor.white,
    headerUnderline = false,
    cardPadding = true
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, {
      [_indexModule.default.cardWhite]: cardColor === CardColor.white,
      [_indexModule.default.cardPadding]: cardPadding
    })
  }, /*#__PURE__*/_react.default.createElement(CardHeader, {
    title: title,
    heading: heading,
    subHeading: subHeading,
    headingProps: headingProps,
    headerElement: headerElement,
    headerUnderline: headerUnderline
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.childrenWrapper
  }, children));
};
var _default = exports.default = Card;